export const loadLink = ({ href, onloadFn = () => { }, rel = 'stylesheet' }) => {
  const linkEl = document.createElement('link')
  linkEl.href = href
  linkEl.rel = rel
  linkEl.onload = (...args) => onloadFn(...args)
  document.head.appendChild(linkEl)
}
